module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/recycling-bins/recycling-bins.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/recycling-bins/recycling-bins.png
// module id = 614
// module chunks = 0